// extracted by mini-css-extract-plugin
module.exports = {"attractionImage":"attractionImage-1SuIc"};